import { IProductAmount } from '@services/queries/equipments/createEquipments/createEquipments';
import { ProductRequest } from '@pages/Products/components/AddEquipmentModal/AddEquipmentModal';

export const getProductAmount = (
  products: ProductRequest[],
): IProductAmount[] => {
  const result = products.map(product => {
    return {
      productId: product.product?.id,
      manufacturerId:
        product.product?.manufacturerId || product.manufacturerId || '',
      amount: product.quantity,
      tempProductName: product.tempProductName,
    };
  });

  return result;
};
